// extracted by mini-css-extract-plugin
module.exports = {"pincode":"Pincode_pincode__guFgj","divider":"Pincode_divider__v8Z2O","label":"Pincode_label__uu_Sa"};